import type { ComputedRef } from 'vue'
import { ExperimentCookieName, ExperimentName } from '../types'
import { computed, useExperiment, useExperimentVersions } from '#imports'

/** The active signup experiment version for this visitor, or null when the experiment is off. */
export const useSignupVersion = (): ComputedRef<string | null> => {
    const versions = useExperimentVersions(ExperimentName.SIGNUP)
    const experiment = useExperiment({ cookieName: ExperimentCookieName.SIGNUP, experimentName: ExperimentName.SIGNUP })

    return computed(() => versions?.[experiment.value] ?? null)
}
